import { 
    SPLIT_ORDERS,
    SPLIT_ORDERS_SUCCESS,
    SPLIT_ORDERS_FAIL,
    CREATE_SUB_BATCH_NEW,
    CREATE_SUB_BATCH_NEW_SUCCESS,
    CREATE_SUB_BATCH_NEW_FAIL,
    MARK_AS_REMOTE_ORDERS,
    MARK_AS_REMOTE_ORDERS_SUCCESS,
    MARK_AS_REMOTE_ORDERS_FAIL,
    FILTER_REMOTE_ORDERS,
    FILTER_REMOTE_ORDERS_SUCCESS,
    FILTER_REMOTE_ORDERS_FAIL,
    GET_BLIND_SCAN_BATCH_LIST,
    GET_BLIND_SCAN_BATCH_LIST_SUCCESS,
    GET_BLIND_SCAN_BATCH_LIST_FAIL,
    SET_BLIND_SCAN_BATCH_EFFECT,
    SET_BLIND_SCAN_BATCH_EFFECT_SUCCESS,
    SET_BLIND_SCAN_BATCH_EFFECT_FAIL
} from '../actions/types';

const initialState = {
    splitOrders: [],
    splitOrdersLoading: false,
    splitOrdersError: false,
    createSubBatchNew: [],
    createSubBatchNewLoading: false,
    createSubBatchNewError: false,
    markAsRemoteOrders: [], 
    markAsRemoteOrdersLoading: false,
    markAsRemoteOrdersError: false,
    filterRemoteOrders: [], 
    filterRemoteOrdersLoading: false,
    filterRemoteOrdersError: false,
    getBlindScanBatchList: [],
    getBlindScanBatchListLoading: false,
    getBlindScanBatchListError: false,
    setBlindScanBatchEffect: [],
    setBlindScanBatchEffectLoading: false,
    setBlindScanBatchEffectError: false
}

export default function smReducer(state = initialState, action){
    switch(action.type){
        case SPLIT_ORDERS:
            return {
                ...state,
                splitOrdersLoading: true,
            }
        case SPLIT_ORDERS_SUCCESS:
            return {
                ...state,
                splitOrders: action.payload,
                splitOrdersLoading: false
            }
        case SPLIT_ORDERS_FAIL:
            return {
                ...state,
                splitOrdersLoading: false,
                splitOrdersError: action.payload
            }
        case CREATE_SUB_BATCH_NEW:
            return {
                ...state,
                createSubBatchNewLoading: true,
            }
        case CREATE_SUB_BATCH_NEW_SUCCESS:
            return {
                ...state,
                createSubBatchNew: action.payload,
                createSubBatchNewLoading: false
            }
        case CREATE_SUB_BATCH_NEW_FAIL:
            return {
                ...state,
                createSubBatchNewLoading: false,
                createSubBatchNewError: action.payload
            }
        case MARK_AS_REMOTE_ORDERS:
            return {
                ...state,
                markAsRemoteOrdersLoading: true,
            }
        case MARK_AS_REMOTE_ORDERS_SUCCESS:
            return {
                ...state,
                markAsRemoteOrders: action.payload,
                markAsRemoteOrdersLoading: false
            }
        case MARK_AS_REMOTE_ORDERS_FAIL:
            return {
                ...state,
                markAsRemoteOrdersLoading: false,
                markAsRemoteOrdersError: action.payload
            }
        case FILTER_REMOTE_ORDERS:
            return {
                ...state,
                filterRemoteOrdersLoading: true,
            }
        case FILTER_REMOTE_ORDERS_SUCCESS:
            return {
                ...state,
                filterRemoteOrders: action.payload,
                filterRemoteOrdersLoading: false
            }
        case FILTER_REMOTE_ORDERS_FAIL:
            return {
                ...state,
                filterRemoteOrdersLoading: false,
                filterRemoteOrdersError: action.payload
            }
        case GET_BLIND_SCAN_BATCH_LIST:
            return {
                ...state,
                getBlindScanBatchListLoading: true,
            }
        case GET_BLIND_SCAN_BATCH_LIST_SUCCESS:
            return {
                ...state,
                getBlindScanBatchList: action.payload,
                getBlindScanBatchListLoading: false
            }
        case GET_BLIND_SCAN_BATCH_LIST_FAIL:
            return {
                ...state,
                getBlindScanBatchListLoading: false,
                getBlindScanBatchListError: action.payload
            }
        case SET_BLIND_SCAN_BATCH_EFFECT:
            return {
                ...state,
                setBlindScanBatchEffectLoading: true,
            }
        case SET_BLIND_SCAN_BATCH_EFFECT_SUCCESS:
            return {
                ...state,
                setBlindScanBatchEffect: action.payload,
                setBlindScanBatchEffectLoading: false
            }
        case SET_BLIND_SCAN_BATCH_EFFECT_FAIL:
            return {
                ...state,
                setBlindScanBatchEffectLoading: false,
                setBlindScanBatchEffectError: action.payload
            }
        default:
            return state;
    }
}
